// Generated by Claude Code
import { HelpPage } from '#components/domain/auth/help/help-page.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/help')({
  component: RouteComponent,
  staticData: {
    title: 'Help',
  },
  // Optional shareable deep-link that opens a specific document in the doc-view
  // panel on mount, then clears itself.
  validateSearch: (search: Record<string, unknown>): { doc?: string } => ({
    doc: (search.doc as string) ?? undefined,
  }),
})

// No PermissionGuard: /help is always accessible.
function RouteComponent() {
  return <HelpPage />
}
